module.exports = __webpack_public_path__ + "static/media/logoFIGMA.062d1e4d.svg";